import { useState } from 'react';
import { useRouteContext } from '../../../context';
import { DATE_OPTIONS } from '../constants';
import { DateOption } from '../interface';

export const useDateSelection = () => {
    const { location, parsedValues, history } = useRouteContext();

    const urlDate = DATE_OPTIONS.find(
        (date) => date.searchValue === parsedValues?.date,
    );

    const [dateSelection, changeDateSelection] = useState<DateOption>(
        urlDate ?? DATE_OPTIONS[0],
    );

    const updateRoute = (params: URLSearchParams) => {
        const pathname = location?.pathname;
        const path = `${pathname}?${params.toString()}`;
        history?.push(path);
    };

    const handleDateSelection = (dateValue: DateOption) => {
        const searchParams = new URLSearchParams(location?.search);
        if (dateValue === DATE_OPTIONS[0]) {
            searchParams.delete('date');
        } else {
            searchParams.set('date', dateValue.searchValue);
        }
        updateRoute(searchParams);

        changeDateSelection(dateValue);
    };
    return {
        dateSelection,
        changeDateSelection: handleDateSelection,
    };
};
